import React, { createRef } from 'react';
type LazyLoadedComponentProps = {
  lazyLoading?: any;
  as?: string;
  className?: string;
  children: any;
  id?: string;
  rootMargin?: string;
  onLoad?: () => any;
};

type LazyLoadedComponentState = {
  loaded: boolean;
};
class LazyLoadedComponent extends React.Component<
  LazyLoadedComponentProps,
  LazyLoadedComponentState
> {
  componentRef: any;
  options: any = {};
  constructor(props: LazyLoadedComponentProps) {
    super(props);
    this.componentRef = createRef();
    if (this.props.id) {
      this.options.id = this.props.id;
    }
    this.onLoad = this.onLoad.bind(this);
  }
  state = {
    loaded: false,
  };
  cl = this.props.className || '';
  tag = this.props.as || 'section';
  onLoad() {
    if (this.props.onLoad) {
      this.props.onLoad();
    }
  }
  componentDidUpdate(prevProps: LazyLoadedComponentProps): void {
    if (prevProps.className !== this.props.className) {
      this.cl = this.props.className || '';
    }
  }
  componentDidMount() {
    if (this.props.lazyLoading) {
      const observer = new IntersectionObserver(
        (entries, obs) => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              this.setState(() => ({
                loaded: true,
              }));
              this.onLoad();
              obs.disconnect();
            }
          }
        },
        {
          rootMargin: this.props.rootMargin || '100px',
          threshold: 0,
        },
      );
      observer.observe(this.componentRef.current);
      return () => {
        observer.disconnect();
      };
    }
  }

  render() {
    const CustomTag = this.tag;
    return (
      <CustomTag
        {...this.options}
        ref={this.componentRef}
        className={`${this.state.loaded ? 'loaded' : ''} ${this.props.className || ''}`}>
        {this.props.children}
      </CustomTag>
    );
  }
}

export default LazyLoadedComponent;
